
<div class="notifications-container">

  <!-- Notifications Header -->
  <div class="back-header notifications-header">

    <div class="back-icon" (click)="BackAsha()">
      <i class="dx-icon dx-icon-chevronleft"></i>
    </div>

    <div class="back-text">Notifications</div>

    <div class="header-actions">

      <button
        class="mark-all-btn"
        [disabled]="isLoading"
        (click)="markAllAsRead()">
        <span class="btn-icon">✓</span>
        <span class="btn-label">Mark all read</span>
      </button>

      <div class="pagination-controls">

        <button
          class="pager-btn"
          [disabled]="currentPage === 1 || isLoading"
          (click)="prevPage()">
          ← Prev
        </button>

        <span class="page-indicator">
          Page {{ currentPage }}
        </span>

        <button
          class="pager-btn"
          [disabled]="!hasNextPage || isLoading"
          (click)="nextPage()">
          Next →
        </button>

      </div>
    </div>
  </div>

  <!-- Notification List -->
  <div
    class="notification-list"
    *ngIf="NotificationList?.length; else emptyState">

    <div
      class="notification-item"
      *ngFor="let item of NotificationList"
      [class.unread]="!item.p.is_read"
      (click)="onNotificationClick(item)">

      <div class="notification-icon">
        <svg width="18" height="18"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="2"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      </div>

      <div class="content">
        <div class="title-row">

          <div class="notification-title">
            {{ item.p.title }}
          </div>

          <div class="notification-time">
            {{ getTimeLabel(item.p.trans_date_time) }}
          </div>

        </div>
      </div>

    </div>
  </div>

  <ng-template #emptyState>
    <div class="notification-empty">
      No notifications yet
    </div>
  </ng-template>

</div>
